import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import theme from '@sm/wds-core/dist/themes/SurveyMonkey.json';

const BACKGROUND_COLOR = theme['brand-color']['color--slate'];
const ANIMATION_COLOR = theme['brand-color']['color--slate'];

const SkeletonLoader = props => {
  const { children, ...contentLoaderProps } = props;

  return <ContentLoader {...contentLoaderProps}>{children}</ContentLoader>;
};

SkeletonLoader.propTypes = {
  children: PropTypes.node,
  primaryColor: PropTypes.string,
  primaryOpacity: PropTypes.number,
  secondaryColor: PropTypes.string,
  secondaryOpacity: PropTypes.number,
  speed: PropTypes.number
};

SkeletonLoader.defaultProps = {
  children: null,
  // background
  primaryColor: BACKGROUND_COLOR,
  primaryOpacity: 0.08,
  // animation
  secondaryColor: ANIMATION_COLOR,
  secondaryOpacity: 0.18,
  speed: 2
};

export default SkeletonLoader;
